import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import { withRouter } from 'kts-platform-frame/routes';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { loginUrl } from 'kts-platform-frame/entry/configUtils';
import { Link } from 'react-router-dom';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import { AppKey } from 'kts-platform-frame/entry/constant';
import RecentlyVisited from 'src/display/components/RecentlyVisited/index';
import service from 'kts-platform-frame/service';
import { OPEN_TYPE } from 'kts-platform-frame/appSdk/openApp';
import Advisory from 'kts-qiyu-advisory';
import AppSdk from 'kts-platform-frame/appSdk';
import { Menu, Dropdown, Tooltip, Timeline } from 'antd';
import { Modal } from 'kts-xui';
import Icon2 from 'kts-platform-frame/display/components/Icon';
import language from 'kts-platform-frame/entry/Language';
import moment from 'moment';
import MyIcon from 'src/display/components/Icon';

const logo = require('./logo.svg');
const bigLogo = require('./bigLogo.svg');

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

class MyState {
    companyInfo: any;
    itemsArr: any;
    updateVersionShow: boolean = false;
    visible: boolean = false;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@withRouter
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class extends UIBasic<IProps, ModulesState, MyState> {

    state = new MyState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    setIsShowMenuHandler = () => {
        this.modulesState.forceShowMenu = !this.modulesState.forceShowMenu;
        // 点击左上角logo图标菜单重叠bug-l
        // this.modulesState.isShowMenu = !this.modulesState.isShowMenu;
        this.setModulesState();
    }
    private get userTypeString(): string {
        const { userInfo } = MyStore.instance.getState().user;
        const userTypeString: string = language.userTypeToString.get(userInfo.userType);
        return userTypeString || '未知';
    }
    onClose = () => {
        this.setState({
            visible: false
        });
    }
    render() {
        const { user } = MyStore.instance.getState();
        const appInfo = AppSdk.instance && AppSdk.instance.user && AppSdk.instance.user['appInfo'];
        const userInfo = AppSdk.instance && AppSdk.instance.user && AppSdk.instance.user.userInfo;
        return (
            <div className={css.header} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'inline-block' }} onClick={this.setIsShowMenuHandler}>
                    <img
                        className={css.menuIcon}
                        src={(this.modulesState.forceShowMenu || this.modulesState.isShowMenu) ? bigLogo : logo}
                    />
                </div>
                
                <ul className={css.menu} >
                <span style={{ paddingRight: 20 ,color:'#CDCDCB'}}>{this.state.companyInfo && this.state.companyInfo.name}</span>
                    {
                        userInfo.email === 'ful0eerk@worldzipcodes.net' && this.renderTemporary()
                    }
                    <li style={{ padding: '6px 6px' }}>
                        <RecentlyVisited userInfo={userInfo} />
                    </li>
                    {/* <li style={{ padding: '5px 4px' }}>
                        <Tooltip placement="bottom" title="返回旧版">
                            <a onClick={this.onClickSwitchVersionHandler} >
                                <img height="20" src={require('./img.switch.version.svg')} alt="" />
                            </a>
                        </Tooltip>
                    </li> */}

                    {/* <li>
                        <Advisory useCustomIcon={true}>
                            <Tooltip placement="bottom" title="帮助中心">
                                <img height="20" src={require('./img.help.svg')} alt="" />
                            </Tooltip>
                        </Advisory>
                    </li> */}
                    {this.renderHelpCenter()}
                    {this.renderSetting()}
                    {this.renderCompanyLogo()}
                    {this.renderAvatar()}
                </ul>
                {this.renderUpdateVersion()}
                <Modal
                    title=" "
                    footer={null}
                    onCancel={this.onClose}
                    width={300}
                    visible={this.state.visible}
                    bodyStyle={{ textAlign: 'center' }}
                >
                    <img style={{ width: '80%' }} src={require('./logo2.png')} />
                    <p></p>
                    <img style={{ width: '70%', margin: '20px 0' }} src={require('./qrcode.png')} />
                    <p style={{ textAlign: 'center', fontWeight: 'bold' }}>请加我的企业微信</p>
                </Modal>
            </div>
        );
    }

    componentDidMount() {
        this.updateCompanyInfo();
        this.getVersion();
    }

    private renderTemporary = () => {
        return (
            <div className={css.temporaryPlatform}>
                <li>
                    <a target='_blank' onClick={() => this.openNewPlatform(1)}>申报平台</a>
                </li>
                <li>
                    <a target='_blank' onClick={() => this.openNewPlatform(2)}>风控平台</a>
                </li>
                <li style={{ width: '95px' }}>
                    <a target='_blank' onClick={() => this.openNewPlatform(3)}>电子会计档案</a>
                </li>
            </div>
        );

    }

    /** 跳转新平台 */
    private openNewPlatform = async (type: number) => {
        if (type === 3) {
            window.open(`https://ecm-demo.maycur.com`);
        } else {
            const url = '/limo-integration/auth/getAccount';
            const info = await service.get(url).end(this);
            if (!info.err && info.res) {
                const userInfo = info.res;
                if (type === 1) {
                    window.open(`http://39.98.142.203:8001/#/mainshow?userName=${encodeURI(userInfo.email)}&source=xunlian`);
                } else if (type === 2) {
                    window.open(`http://58.215.13.190:88/login?username=${userInfo.email}&password=${userInfo.password}`);
                }
            }
        }
    }


    /** 渲染公司 logo */
    private renderCompanyLogo = () => {

        const menu = (
            <Menu className={css.menu2} >
                {
                    this.state.companyInfo &&
                    <Menu.Item>
                        <a onClick={() => this.onClickHandler(`/workbench/m/${AppKey.公司信息}`)}>{this.state.companyInfo.name}</a>
                    </Menu.Item>
                }
                {
                    ModulesAction.isHaveApp(AppKey.切换公司) &&
                    <Menu.Item>
                        <a onClick={this.onClickCompanySwitchHandler} >切换公司</a>
                    </Menu.Item>
                }
            </Menu>
        );

        return (
            <li>
                <Dropdown placement="bottomCenter" overlay={menu}>
                    <div className={css.companyLogo}>
                        {
                            this.state.companyInfo &&
                            <i style={{ backgroundImage: `url(${this.state.companyInfo.imageUrl})` }} />
                        }
                    </div>
                </Dropdown>
            </li>
        );
    }

    /** 头像 */
    private renderAvatar = () => {
        const { user } = MyStore.instance.getState();
        const menu = (
            <Menu className={css.menu2} >
                <Menu.Item>
                    {/* <a onClick={()=>this.onClickHandler("/workbench/platform/userCenter")} >我的信息</a> */}
                    <a onClick={() => this.onClickHandler("/workbench/platform/userCenter")} >{user.userInfo.nickName}/{this.userTypeString}</a>
                </Menu.Item>
                <Menu.Item>
                    <a onClick={() => this.onClickHandler("/workbench/platform/resetPwd")} >修改密码</a>
                </Menu.Item>
                <Menu.Item>
                    <a onClick={this.onClickOutHandler} >安全退出</a>
                </Menu.Item>
            </Menu>
        );
        return (
            <li>
                <Dropdown placement="bottomCenter" overlay={menu} >
                    <img height="20" src={require('./img.headPortrait.svg')} alt="" />
                </Dropdown>
            </li>
        );
    }
    showCode = () => {
        this.setState({
            visible: true
        });

    }
    /** 帮助中心 */
    private renderHelpCenter = () => {
        const { user } = MyStore.instance.getState();
        const companyName = user.userInfo.companyName;

        let isYuJiang = companyName.indexOf('重庆渝江压铸有限公司') >= 0;
        const menu = (
            <Menu className={css.menu2} >

                <Menu.Item>
                    <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=2301730463&site=qq&menu=yes">帮助中心</a>
                    {/* <a>
                        <Advisory useCustomIcon={true}>帮助中心</Advisory>
                    </a> */}
                </Menu.Item>
                <Menu.Item>
                    <a onClick={() => this.onClickHandler(`/guide`)} >新手引导</a>
                </Menu.Item>
                <Menu.Item>
                    <a onClick={this.showCode} >联系客服</a>
                </Menu.Item>
                <Menu.Item>
                    <a onClick={this.onClickUpdateModal} >更新日志{this.state.itemsArr && this.state.itemsArr[0] && this.state.itemsArr[0].version && ('V' + this.state.itemsArr[0].version)}</a>
                </Menu.Item>
                {isYuJiang ? <Menu.Item>
                    <a className="ant-dropdown-menu-item" target="_blank" href="https://shimo.im/docs/8cf013d5823f4a03/" >渝江-VMI操作手册</a>
                </Menu.Item> : null}
                {isYuJiang ? <Menu.Item> <a className="ant-dropdown-menu-item" target="_blank" href="https://shimo.im/docs/5M0vd576klgwL29c/" >渝江-交付操作手册，密码 dyha</a>
                </Menu.Item> : null}
            </Menu>
        );
        return (
            <li>
                <Dropdown placement="bottomCenter" overlay={menu} >
                    <img height="20" src={require('./img.help.svg')} alt="" />
                </Dropdown>
            </li>
        );
    }

    /** 设置 */
    private renderSetting = () => {
        const appkeys = [
            [AppKey.用户管理, '用户管理'],
            [AppKey.角色管理, '角色管理'],
            [AppKey.部门管理, '部门管理'],
            [AppKey.公司信息, '公司管理'],
            [AppKey.集团资料, '集团资料'],
            [AppKey.审计日志, '审计日志'],
            [AppKey.应用管理, '应用管理'],
        ];

        const menuList = appkeys.map((value, index) => {
            return (
                ModulesAction.isHaveApp(value[0])
                    ? <Menu.Item key={index} >
                        <a onClick={() => this.onClickHandler(`/workbench/m/${value[0]}`)} >{value[1]}</a>
                    </Menu.Item>
                    : undefined
            );
        });

        const menu = (
            <Menu className={css.menu2} >
                {menuList}
            </Menu>
        );

        if (menuList.length > 0 && menuList.some(value => !!value)) {
            return (
                <li>
                    <Dropdown placement="bottomCenter" overlay={menu}>
                        <img height="20" src={require('./img.setting.svg')} alt="" />
                    </Dropdown>
                </li>
            );
        } else {
            return <></>;
        }
    }

    /** 更新公司信息 */
    private updateCompanyInfo = async () => {
        const url = '/zone/company/info/get';
        const info = await service.get(url).end(this);

        if (info.err) {
            return;
        }

        this.setState({ companyInfo: info.res });
    }
    /** 获取版本号 */
    private getVersion = async () => {
        const url = '/zone/client/version/platform/page';
        const info = await service.post(url, {
            "pageNum": 1,
            "pageSize": 100,
        }).end(this);

        if (info.err) {
            return;
        }
        this.setState({
            itemsArr: info.res.items
        });
        // console.log(info.res.items, 'info');
    }

    /** 点击了安全退出 */
    private onClickOutHandler = () => {
        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
        // this.props.history.push('/login');
        window.location.href = loginUrl(); //kts.Env.instance().workingUrl('//login{env}kingxunlian.com/');
    }

    private onClickHandler = (url: string) => {
        ModulesAction.setAppBoxVisible(false);
        this.props.history.push(url);
    }
    /** 更新日志弹窗 */
    private renderUpdateVersion = () => {
        return this.state.updateVersionShow && <div className={css.updateVersionShade}>
            <div className={css.updateVersionWrap}>
                <div className={css.headerWrap}>
                    <div className={css.iconWrap}></div>
                </div>
                <div className={css.updateWrap}>
                    <Timeline mode={'left'}>
                        <Timeline.Item color={'#000'}>
                            <div className={css.timelineLabel}>{moment(new Date()).format('YYYY') + '年'}</div>
                            <p style={{ color: '#000', fontSize: '16px', fontWeight: 700, fontFamily: 'PingFangSC-Medium, PingFang SC;' }}>迅联云持续更新中</p>
                        </Timeline.Item>
                        {
                            this.state.itemsArr.map(item => {

                                return <Timeline.Item color={'#000'} key={item.id}>
                                    <div className={css.timelineLabel}>{item.versionUpdateTime && moment(item.versionUpdateTime).format('MM-DD')}</div>
                                    <p style={{ color: '#000', fontSize: '16px', fontWeight: 700, fontFamily: 'PingFangSC-Medium, PingFang SC;' }}>版本：{'V' + item.version}</p>
                                    {
                                        JSON.parse(item.contentJson).map((itm, idx) => {
                                            return itm.helpUrl ? <p key={idx}>
                                                <span style={{ fontSize: '14px', color: '#333' }}>{(idx + 1) + '.' + itm.contentJson}</span>
                                                <a className={css.handIconWrap} href={itm.helpUrl} target="_blank">
                                                    <MyIcon src={require('src/display/components/Icon/help.svg')} color={'#1991EB'} />
                                                </a>
                                            </p> : <p key={idx} style={{ fontSize: '14px', color: '#333' }}>{(idx + 1) + '.' + itm.contentJson}</p>;
                                        })
                                    }
                                </Timeline.Item>;

                            })
                        }
                    </Timeline>
                </div>
                <div className={css.closeBtn} onClick={() => this.setState({ updateVersionShow: false })}></div>
            </div>
        </div>;
    }
    private onClickUpdateModal = () => {
        this.setState({
            updateVersionShow: true
        });
    }

    /** 点击了切换公司 */
    private onClickCompanySwitchHandler = () => {
        ModulesAction.setAppBoxVisible(false);
        AppSdk.instance.openApp(this, {
            appKey: AppKey.切换公司,
            openType: OPEN_TYPE.右侧弹窗,
        });
    }

    /** 切换版本 */
    private onClickSwitchVersionHandler = () => {
        MyStore.instance.dispatch(reducers.system.ActionTypes.setVersion, '0.2');
    }
}




// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench2/UI.Header/index.tsx